import React from "react";
import { AyurvedaPregnancyCard } from "@aph/ui-lib-humanx";
import NextLink from "next/link";
import { useRouter } from "next/navigation";
import IconLeft from "$/icons/icon-left.svg";
import IconPlus from "$/icons/icon-plus.svg";
import IconRight from "$/icons/icon-right.svg";
import { ArticleAttributesInterface } from "@/components/ArticlePage/api/interface";
import Bookmark from "@/components/BookmarkAction";
import ButtonLink from "@/components/ButtonLink";
import { TagItem } from "@/components/PageHome/api/interface";
import Slider, { Slide } from "@/components/Slider";
import sliderStyles from "@/components/Slider/Slider.module.scss";
import { NON_ONBOARDED_STATUS, ONBOARDING_STATUS, TYPE_ARTICLE } from "@/helpers/constants";
import routes from "@/helpers/router";
import { DeviceInfo } from "@/interface/deviceInfo";
import { assetClickedEvent } from "@/helpers/TSDEvents";
import { useAppSelector } from "@/redux/hooks";
import { getPlainTexts } from "@/helpers";
import SegmentInfoSelector from "@/redux/slice/auth/selectors/userSegmentInfo";
import styles from "./RelatedArticles.module.scss";

const RelatedArticles = (props: {
  items: any;
  title: string;
  ctaURL?: string;
  ctaText?: string;
  userAgent: DeviceInfo;
  tags?: TagItem[];
  isCtaLink?: boolean;
  titleClass?: string;
  desktopItems?: number;
  assetPosition?: number;
  isPharma?: boolean;
}) => {
  const {
    items,
    title,
    ctaURL = "#",
    ctaText,
    userAgent,
    tags,
    isCtaLink,
    titleClass,
    desktopItems = 2,
    assetPosition,
    isPharma = false,
  } = props;
  const router = useRouter();

  const SegmentInfoObject = useAppSelector(SegmentInfoSelector);

  return (
    <div className={styles.root}>
      {title && (
        <div
          className={`${styles.title} ${titleClass ? titleClass : ""}`}
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {!!items.length && (
        <div className={`${styles.slidercontainer}`}>
          <Slider
            autoplay={false}
            showArrows={userAgent?.isDesktop}
            showDots={false}
            dotsWrapperClass={sliderStyles.dotsWrapperClass}
            dotClass={sliderStyles.dotClass}
            dotClassActive={sliderStyles.dotClassActive}
            slidesToShow={userAgent?.isDesktop ? desktopItems : 1}
            columnGap={15}
            nextArrow={<IconRight className={`${styles.arrows} ${styles.arrowNext}`} />}
            prevArrow={<IconLeft className={`${styles.arrows} ${styles.arrowPrev}`} />}
          >
            {items?.map((item: ArticleAttributesInterface, index: number) => {
              const redirectUrl = routes.article(item?.Slug);

              return (
                <Slide key={`ra-${item?.id}`} index={index} className={styles.sliderRoot}>
                  <AyurvedaPregnancyCard
                    //TODO: not fot mvp
                    // tagLists={tags?.map((tag) => {
                    //   return {
                    //     label: tag?.data?.attributes?.TagName,
                    //     onClick: () => {
                    //       handleTagClick(tag);
                    //     },
                    //   };
                    // })}
                    ImageUrl={item?.Image?.data?.attributes?.url}
                    title={item?.Title}
                    labelText={item?.ReadTime}
                    authorName={item?.AuthorName}
                    authorIcon={<IconPlus width={13} height={13} />}
                    onCardClick={() => {
                      assetClickedEvent({
                        asset_name: getPlainTexts(title),
                        asset_display_text: item?.Title,
                        asset_position: assetPosition,
                        asset_element_position: index + 1,
                        momverse_stage: SegmentInfoObject?.type
                          ? (ONBOARDING_STATUS[SegmentInfoObject?.type] ?? "")
                          : NON_ONBOARDED_STATUS,
                      });
                      router.push(redirectUrl);
                    }}
                    redirectUrl={redirectUrl}
                    isImageCover
                    bookmark={<Bookmark itemId={item?.id} type={TYPE_ARTICLE} section={title} isPharma={isPharma} />}
                  />
                </Slide>
              );
            })}
          </Slider>
        </div>
      )}
      {ctaText &&
        (isCtaLink ? (
          <NextLink className={styles.ctaLink} href={ctaURL} prefetch={false}>
            {ctaText} <IconRight height={20} width={20} />
          </NextLink>
        ) : (
          <ButtonLink color="primarybaby" href={ctaURL} className={styles.btn}>
            {ctaText}
          </ButtonLink>
        ))}
    </div>
  );
};

export default RelatedArticles;
